import React from "react";

import logo from "../assets/images/logo.png";

import classes from "./Banner.module.css";
import {Slide} from "react-awesome-reveal";

function Banner() {
    return (
        <div className={classes.Banner}>
            <Slide triggerOnce direction="up">
                <div className={classes.content}>
                    <img className={classes.logo} src={logo} alt='logo'/>
                    <div className={classes.title}>Casa Kotys</div>
                    <div className={classes.subtitle}>HOSTING & LODGING</div>
                </div>
            </Slide>

        </div>
    );
}
export default Banner;
